export default "__VITE_ASSET__5ajy3nUR__"